/* eslint-disable prettier/prettier */
import storageService from 'lib/storageService';
import ApiClient from 'lib/apiClient';
import FileClient from 'lib/fileClient';

// Debug logging
console.log('Environment REACT_APP_API_ROOT:', process.env.REACT_APP_API_ROOT);
console.log('Full API basePath:', `${process.env.REACT_APP_API_ROOT}/v1/api/`);

// Temporary fix: Hardcode the API root for production
const API_ROOT = process.env.REACT_APP_API_ROOT ?? '';

console.log('Final API_ROOT being used:', API_ROOT);
console.log('Final basePath:', `${API_ROOT}/`);
console.log('Environment NODE_ENV:', process.env.NODE_ENV);
console.log(
  'All environment variables:',
  Object.keys(process.env).filter((key) => key.startsWith('REACT_APP_')),
);

export const apiClient = new ApiClient({
  basePath: `${API_ROOT}/`,
  fetchConfig: {
    headers: {
      Accept: 'application/json',
      'Access-Control-Allow-Methods': '*',
      // "Access-Control-Allow-Origin": "true",
      // mode: "no-cors",
    },
  },
  methods: ['get', 'post', 'put', 'patch', 'delete', 'GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
});

apiClient.setToken(storageService.get('token'));

export const fileClient = new FileClient({
  basePath: `${API_ROOT}/`,
  fetchConfig: {
    headers: {
      Accept: 'application/zip',
      'Access-Control-Allow-Methods': '*',
      // "Access-Control-Allow-Origin": "true",
      // mode: "no-cors",
    },
  },
  methods: ['get', 'post', 'put', 'patch', 'delete', 'GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
});

fileClient.setToken(storageService.get('token'));

// Test API connection
console.log('Testing API connection...');
fetch(`${API_ROOT}/v1/api/token/`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ username: 'test', password: 'test' }),
})
  .then((response) => {
    console.log('API Response Status:', response.status);
    console.log('API Response Headers:', response.headers);
    return response.text();
  })
  .then((text) => {
    console.log('API Response Body (first 200 chars):', text.substring(0, 200));
  })
  .catch((error) => {
    console.error('API Connection Error:', error);
  });
